/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PreloadedQuery } from 'react-relay';
import type { ThemeSetterQuery } from '@jira/platform__project-theme-setter/src/__generated__/ThemeSetterQuery.graphql';
// eslint-disable-next-line jira/import/no-restricted-import
import { fieldsResource } from '@jira/router-resources__business-fields/src/fieldsResource.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import type { ProjectDetailsResource } from '@jira/router-resources__business-project-details/src/ProjectDetailsResource.types.tsx';
import {
	// eslint-disable-next-line jira/import/no-restricted-import, camelcase
	DEPRECATED_DO_NOT_USE_projectDetailsResource,
} from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const getBusinessProjectResources = (): (
	| RouteResource<ProjectDetailsResource>
	| RouteResource<PreloadedQuery<ThemeSetterQuery, Record<string, unknown>>>
)[] => [
	// eslint-disable-next-line camelcase
	DEPRECATED_DO_NOT_USE_projectDetailsResource,
	projectThemeResource,
];
export const getProjectViewResources = (): RouteResource[] => [
	...getBusinessProjectResources(),
	...getNavigationResources(),
	// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
	// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
	projectContextResource,
	forgeProjectModuleResource,
	staticProjectSidebarNavigationResource,
	staticProjectSidebarConnectAddonsNavigationResource,
	// end of resources expanded from getNavigationSidebarProjectResource
	fieldsResource,
];
